import { render, staticRenderFns } from "./ContentTesti.vue?vue&type=template&id=0b5a5a2d"
import script from "./ContentTesti.vue?vue&type=script&lang=js"
export * from "./ContentTesti.vue?vue&type=script&lang=js"
import style0 from "./ContentTesti.vue?vue&type=style&index=0&id=0b5a5a2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports